// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GoToTop_wrapper__PJXAr"};